function AdBanner(){

return(

<div style={{
margin:"20px",
padding:"20px",
background:"#eee",
textAlign:"center"
}}>

Ad Space (Google AdSense)

</div>

)

}

export default AdBanner;